import { isStateEligibleForAddon } from "src/utils/addonEligibility";
import { getMedState } from "src/utils/medEligibility";
import { getActiveShopEntry } from "src/utils/shopProducts";
import {
  isEligibleForMedAfterZipcodeQuestion,
  isShopLayer,
  isZipcodeCorrespondingToUSState,
} from "src/utils/userSegment/features";

export type ZipcodeEligibilityStatus =
  | "valid"
  | "stateAndConditionIneligible"
  | "stateIneligible";

function getAddonShopZipcodeEligibilityStatus(): ZipcodeEligibilityStatus {
  if (!isZipcodeCorrespondingToUSState()) {
    return "stateIneligible";
  }

  const entry = getActiveShopEntry();
  if (!entry || entry.type !== "addon") {
    return "stateIneligible";
  }

  return isStateEligibleForAddon(entry.addonSku, getMedState())
    ? "valid"
    : "stateIneligible";
}

export function getZipcodeEligibilityStatus(): ZipcodeEligibilityStatus {
  if (isShopLayer()) {
    return getAddonShopZipcodeEligibilityStatus();
  }

  if (!isEligibleForMedAfterZipcodeQuestion()) {
    return "stateAndConditionIneligible";
  }
  if (!isZipcodeCorrespondingToUSState()) {
    return "stateIneligible";
  }
  return "valid";
}
